import React, { useState } from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';
import { Plus } from 'lucide-react';

interface AddTodoModalProps {
    show: boolean;
    onHide: () => void;
    onAdd: (text: string) => Promise<void>;
    submitting?: boolean;
}

export const AddTodoModal: React.FC<AddTodoModalProps> = ({
    show,
    onHide,
    onAdd,
    submitting = false
}) => {
    const [text, setText] = useState('');
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = async (e?: React.FormEvent) => {
        if (e) e.preventDefault();

        if (!text.trim()) {
            setError('Text krävs');
            return;
        }

        try {
            await onAdd(text);
            setText('');
            setError(null);
            onHide();
        } catch (err: any) {
            setError(err.message || 'Kunde inte lägga till uppgift');
        }
    };

    const handleClose = () => {
        setText('');
        setError(null);
        onHide();
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Ny uppgift</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    {error && (
                        <Alert variant="danger" dismissible onClose={() => setError(null)} className="mb-3">
                            {error}
                        </Alert>
                    )}
                    <Form.Group>
                        <Form.Label>Uppgift *</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    handleSubmit();
                                }
                            }}
                            placeholder="Beskriv uppgiften..."
                            required
                            autoFocus
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose} disabled={submitting}>
                        Avbryt
                    </Button>
                    <Button variant="primary" type="submit" disabled={submitting}>
                        <Plus size={18} className="me-1" />
                        {submitting ? 'Lägger till...' : 'Lägg till'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};
